var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoVue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 261.76 226.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#41b883",
    d: "m161.096.001-30.225 52.351L100.647.001H-.005l130.877 226.688L261.749.001z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34495e",
    d: "m161.096.001-30.225 52.351L100.647.001H52.346l78.526 136.01L209.398.001z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVue);
export default __webpack_public_path__ + "static/media/logo-vue.60b46fc01bc47653080baf67194a4934.svg";
export { ForwardRef as ReactComponent };